(function(){
    'use strict'

    angular
    .module('app.variables')
    .controller('EditarVariable', EditarVariable);

    EditarVariable.$inject = ['$scope', '$animationsSrv', '$routeParams','VariablesService', 'logger', '$location'];

    function EditarVariable($scope, $animationsSrv, $routeParams, VariablesService, logger, $location) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.variableId = $routeParams.id ? $routeParams.id : 0;

        getVariable();

        function getVariable(){

            if(vm.variableId != 0){
                var promise = VariablesService.getById(vm.variableId);

                promise
                .then(function(variable){
                    vm.variable = variable;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener el variable: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        vm.save = function(){

            $scope.submitted = true;

            if($scope.variableForm.$valid){
                if(!vm.variable.id){
                    saveVariable();
                }
                else if($scope.variableForm.$dirty){
                    updateVariable();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveVariable() {
            var promise = VariablesService.save(vm.variable);
            
            promise
            .then(function(response){
                logger.success('Variable creado con éxito.');
                clearVariableData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el variable: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateVariable(){
            var promise = VariablesService.update(vm.variable);
            
            promise
            .then(function(response){
                logger.success('Variable modificado con éxito.');
                $location.path('/variables');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el variable: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearVariableData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.variable = {};
            // Set back to pristine.
            $scope.variableForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.variableForm.$setUntouched();
        };

    }
})();